import { AppointmentSummary } from '../../entities';
import { DateTime } from 'luxon';

export enum AppointmentRequestType {
    Create = 'Create',
    Edit = 'Edit',
    Cancel = 'Cancel',
    ReAssign = 'ReAssign',
    Dispatched = 'Dispatched',
    Deleted = 'Deleted'
}

export enum DispatchByType {
    Group = 'Group',
    Technician = 'Technician'
}

export interface WorkOrderAppointmentRequest {
    type: AppointmentRequestType;
    appointments: AppointmentSummary[];
    technicianId: string;
}

export interface DeletedWorkOrderRequest {
    workOrderId: string;
    appointmentId: string;
}

export interface AppointmentPipelineRequest {
    date?: string;
    technicianId?: string;
    dispatchBy?: DispatchByType;
    appointmentId?: string;
    workOrderId?: string;
    type: AppointmentRequestType;
}
